import { render, staticRenderFns } from "./CityInfoCard.vue?vue&type=template&id=487a4720&scoped=true&"
import script from "./CityInfoCard.vue?vue&type=script&lang=js&"
export * from "./CityInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./CityInfoCard.vue?vue&type=style&index=0&id=487a4720&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487a4720",
  null
  
)

export default component.exports